module.exports = __webpack_public_path__ + "r-v3/img/link_blue.05515a2e.svg";